import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DialogNotificationService } from './dialog-notification.service';

@Component({
    selector: 'jhi-dialog-notification',
    templateUrl: './dialog-notification.component.html'
})
export class DialogNotificationComponent implements OnInit, OnDestroy {
    messageKey: string;
    messageParams: any;

    constructor(
        public activeModal: NgbActiveModal,
        public dialogNotificationService: DialogNotificationService,
    ) {
    }

    ngOnInit() {
        this.messageKey = this.dialogNotificationService.getMessageKey();
        this.messageParams = this.dialogNotificationService.getMessageParams();
    }

    ngOnDestroy() {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }
}

@Component({
    selector: 'jhi-dialog-notification-popup',
    template: ''
})
export class DialogNotificationPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private dialogNotificationService: DialogNotificationService,
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.dialogNotificationService
                .open(DialogNotificationComponent as Component, params['messageKey'], params['messageParams']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}
